// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZMIm","newExpiryDate":"styles_newExpiryDate__1rop0","footer":"styles_footer__T-qvo"};